import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import { useState } from 'react';
import LabReportUpload from '../LabReportUpload/LabReportUpload';
import AudioPlayback from '../AudioPlayback/AudioPlayback';
import FaceRecognition from '../FaceRecognition/FaceRecognition';
import AudioSettings from '../AudioSettings/AudioSettings';
import AmbientListening from '../AmbientListening/AmbientListening';
import { useSession } from '../../contexts/SessionContext';
import {
  CloudUpload,
  AudioFile,
  FaceRetouchingNatural,
  Settings,
  Mic,
} from '@mui/icons-material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`advanced-tabpanel-${index}`}
      aria-labelledby={`advanced-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AdvancedFeatures() {
  const [activeTab, setActiveTab] = useState(0);
  const { session } = useSession();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 600 }}>
        Advanced Features
      </Typography>

      <Paper sx={{ borderRadius: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="advanced features tabs"
            sx={{
              '& .MuiTab-root': {
                minHeight: 64,
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
              },
            }}
          >
            {/* Ambient Listening Tab - Removed as per requirement */}
            {/* <Tab
              icon={<Mic />}
              iconPosition="start"
              label="Ambient Listening"
              id="advanced-tab-0"
            /> */}
            <Tab
              icon={<CloudUpload />}
              iconPosition="start"
              label="Lab Reports & Vision AI"
              id="advanced-tab-0"
            />
            <Tab
              icon={<AudioFile />}
              iconPosition="start"
              label="Audio Playback"
              id="advanced-tab-1"
            />
            <Tab
              icon={<FaceRetouchingNatural />}
              iconPosition="start"
              label="Digital Signature"
              id="advanced-tab-2"
            />
            <Tab
              icon={<Settings />}
              iconPosition="start"
              label="Audio Settings"
              id="advanced-tab-3"
            />
          </Tabs>
        </Box>

        {/* Ambient Listening Panel - Removed */}
        {/* <TabPanel value={activeTab} index={0}>
          <AmbientListening sessionId="demo-session" />
        </TabPanel> */}

        <TabPanel value={activeTab} index={0}>
          <LabReportUpload
            sessionId={session?.session_id}
            onUploadComplete={(file) => console.log('Upload complete:', file)}
          />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <AudioPlayback />
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <FaceRecognition
            onSignatureComplete={(data) => console.log('Signature complete:', data)}
          />
        </TabPanel>

        <TabPanel value={activeTab} index={3}>
          <AudioSettings
            onSettingsChange={(settings) => console.log('Settings changed:', settings)}
          />
        </TabPanel>
      </Paper>
    </Box>
  );
}
